import React from 'react';
import './Plan.css';

type Step = {
  title: string;
  text: string;
};

type PlanProps = {
  steps: Step[];
  mainTitle: string;
  intro: React.ReactNode;
};

const Plan: React.FC<PlanProps> = ({ steps, mainTitle, intro }) => (
  <div className="timeline-container">
    <h1 className="timeline-title">{mainTitle}</h1>
    <p className="timeline-intro">{intro}</p>
    <div className="timeline-list">
      {steps.map((step, idx) => (
        <div className="timeline-item" key={idx}>
          <div className="timeline-marker">
            <span className="timeline-number">{idx + 1}</span>
            {idx < steps.length - 1 && <span className="timeline-line"></span>}
          </div>
          <div className="timeline-content">
            <h2 className="timeline-step-title">{step.title}</h2>
            <p className="timeline-step-text">{step.text}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Plan;
